<template>
  <div class="" style="padding:4px 20px 4px 20px; margin-bottom:4px;">
    <div v-if="onNull(frameFile, '').length > 0 && !invisible" class="d-flex flex-column align-center" >
        <h3 style="font-size: .95em; color: gray; text-align: center;" v-if="onNull(title, '').length">{{title}}</h3>
        <v-skeleton-loader
          v-if="!fromFileLoaded"
          type="image"
          width="300"
          height="200"/>
        <img v-show="fromFileLoaded"
          :src="videoFileBaseURL + frameFile"
          class="elevation-2"
          style="height: 200px; border-radius: 5px; cursor: pointer; max-width: 400px; object-fit: cover"
          v-on:click="show" title="click to watch video"
          @load="fromFileLoaded = true"
          @error="fromFileLoaded = true" />
        <!--<v-img :src="videoFileBaseURL + frameFile" v-on:click="show" title="click to watch video" class="elevation-2" style="height: 200px; border-radius: 5px; cursor: pointer; max-width: 400px; object-fit: cover">
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5">
              </v-progress-circular>
            </v-row>
          </template>
        </v-img>-->
        <div class="frazier-blue-font mt-2" style="font-size: .85em; text-align: center;" v-if="onNull(description, '').length"><MyHtml :value="description"></MyHtml></div>
        <div style="font-size: .7em; font-style: italic; color: gray; text-align: center;">click image to watch video</div>
      </div>
      <div v-else-if="!invisible" v-on:click="show" style="width: 300px;">
        <h3 style="font-size: .95em; color: black; text-align: center;" v-if="onNull(title, '').length">{{title}}</h3>
        <div class="default-video" style="padding: 10px 100px; border: 1px solid lightgray; border-radius: 10px; cursor: pointer; ">
          <Fa duo style="font-size: 100px; color: gray; background: transparent;" title="click to watch video">play-circle</Fa>
        </div>
        <div class="frazier-blue-font mt-2" style="font-size: .85em; text-align: center;" v-if="onNull(description, '').length"><MyHtml :value="description"></MyHtml></div>
        <div style="font-size: .7em; font-style: italic; color: gray; text-align: center;">click to play</div>
      </div>

    <MyModal ref="video" :header="title" @after-hide="onHide" style="color:gray; text-align:center;">
      <div v-if="showVideo" style="display: flex; flex-flow: column; justify-content: center; align-items: center; background-color: black;">
        <video style="height: 700px;" controls autoplay preload="none">
          <source :src="videoFileBaseURL + videoFile" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </MyModal>
  </div>
</template>

<script>
import { randomString } from '@/functions'
import { videoFileBaseURL } from '@/constants'
export default {
  props: {
    videoFile: null,
    frameFile: null,
    title: null,
    posted: null,
    description: null,
    invisible: Boolean,
    emitShow: Boolean
  },
  data() {
    return {
      id: randomString(),
      showVideo: false,
      videoFileBaseURL: videoFileBaseURL,
      fromFileLoaded: false
    }
  },
  computed: {
    // videoUrl() {
    //   return `https://video.frazier.com/videos/customer%20portal/${this.videoFile}`
    // },
    // frameUrl() {
    //   return `https://video.frazier.com/videos/customer%20portal/${this.frameFile}`
    // }
  },
  methods: {
    show() {
      // this.$modal.show(this.id)
      if (!this.emitShow) {
        this.$refs.video.show()
        this.showVideo = true
      } else {
        this.$emit('show')
      }
    },
    onHide() {
      setTimeout(() => {
        this.showVideo = false
      }, 500)
      this.$emit('after-hide')
    }
  }
}
</script>

<style lang="scss" scoped>
  .default-video {
    &:hover {
      // background-color: lightgray;
    }

    // background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
    background: linear-gradient(-45deg, #dddddd, white, #dddddd, white);

    background-size: 400% 400%;
    animation: gradient 15s ease infinite;
    // height: 100vh;

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  }
</style>
